module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addCustomerButton.errorMessage":"There was an error encountered while creating this customer. If everything looks right please contact support.","addCustomerButton.submit":"Submit"}}')
  delete Component.options._Ctor
}
